import { Component } from 'preact';
import { Portal, ErrorBoundary } from '@/components';
import api from '@/api';
import { isArray, isPreviewPage } from '@/utils';
import { App } from '@/features/form';

import { ManagerProvider } from '../stores/ManagerStore';
import Styles from './Styles';

//Class to manager hide/show forms, load config and handle styles

class FormManager extends Component {
	state = {
		config: {},
		styles: {},
		themes: [],
		formKeys: []
	};

	componentDidMount() {
		//const config = getStorage('__mState');
		//const { webView } = this.props;
		// if (typeof config === 'object' && !this.isPreviewPage && !webView) {
		// 	this.setState({...config}, () => this.updateForms());
		// } else {
		//for now always skip storage and fetch from server
		this.updateForms();
		//}
	}

	componentDidUpdate(prevProps) {
		this.updateForms(prevProps);
	}

	updateForms = (prevProps = {}) => {
		const { forms } = this.props;
		forms.forEach(form =>
			this.handleUpdate(
				form,
				prevProps?.forms?.filter(prev => prev.formKey === form.formKey)[0]
			)
		);
	};

	handleUpdate = (form, prevForm = {}) => {
		const { formKey, refresh } = form;
		const { config } = this.state;
		if (!config[formKey]) {
			this.updateConfig(formKey, {}, () => {
				this.loadConfig(form);
			});
		}

		if (refresh && prevForm.refresh !== refresh) {
			this.setState(
				prevState => ({
					...prevState,
					config: {
						...prevState.config,
						[form.formKey]: {}
					}
				}),
				() => {
					this.loadConfig(form);
				}
			);
		}
	};

	updateConfig = (formKey, update, callback = () => {}) => {
		this.setState(
			prevState => ({
				...prevState,
				config: {
					...prevState.config,
					[formKey]: Object.assign({}, prevState.config[formKey] ?? {}, update)
				}
			}),
			() => {
				//setStorage('__mState', this.state);
				callback();
			}
		);
	};

	loadConfig = ({
		domain,
		formKey,
		webView,
		noCache,
		customDomain,
		cacheDomain,
		feedbackDomain,
		refresh
	}) => {
		const { styles } = this.state;

		api({
			domain,
			formKey,
			webView,
			noCache,
			customDomain,
			cacheDomain,
			feedbackDomain,
			refresh
		})
			.getConfig(!styles.base, isPreviewPage())
			.then(response => {
				//in case something goes wrong stop
				if (!isArray(response?.layout)) return;

				if (typeof response.css === 'object' && Object.keys(response.css).length > 0) {
					this.setState(prevState => ({
						styles: { ...prevState.styles, ...response.css },
						themes: [...prevState.themes, response.themeClass],
						formKeys: [...prevState.formKeys, formKey]
					}));
				}

				this.updateConfig(formKey, response);
			});
	};

	renderForm = (form, index = null) => {
		const { isMultiple } = this.props;
		const { config, styles, themes } = this.state;

		const setRef = (node, isPortal) => {
			const ref = isPortal ? 'portal-' + form.formKey : form.formKey;
			if (index !== null) {
				if (!this[ref] || typeof this[ref] !== 'object') this[ref] = {};
				this[ref][index] = node;
			} else {
				this[ref] = node;
			}
		};

		if (!form.divName) return null;

		const key = (index ? form.formKey + index : form.formKey) + form.instance;

		return (
			<ErrorBoundary>
				<Portal
					into={form.divName}
					key={key}
					ref={node => setRef(node, true)}
				>
					{config[form.formKey] && Object.keys(config[form.formKey]).length > 0 && (
						<App
							{...form}
							form={form}
							ref={node => setRef(node, false)}
							multipleIndex={index}
							initialConfig={config[form.formKey]}
							styles={styles}
							themes={themes}
						/>
					)}
				</Portal>
			</ErrorBoundary>
		);
	};

	render(props) {
		const { forms } = this.props;

		const cssDomain = forms?.[0]?.cssDomain;
		const cacheDomain = forms?.[0]?.cacheDomain;
		const customDomain = forms?.[0]?.customDomain;

		return (
			<div>
				<ManagerProvider value={this.state}>
					<Portal into={document.head}>
						<Styles
							cssDomain={cssDomain}
							cacheDomain={cacheDomain}
							customDomain={customDomain}
						/>
					</Portal>
					{props.forms.map(form => {
						return isArray(form.divName)
							? form.divName.map((div, i) =>
									this.renderForm(Object.assign({}, form, { divName: div }), i)
							  )
							: this.renderForm(form, 0);
					})}
				</ManagerProvider>
			</div>
		);
	}
}

export default FormManager;
